// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h3[data-v-ff3510a0] {\n  font-weight: 600;\n  font-size: .75rem;\n}\n@media (min-width: 768px) {\nh3[data-v-ff3510a0] {\n    font-size: .9rem;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
